var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4453 1.62987C5.56894 1.44441 5.7771 1.33301 6 1.33301H10C10.2229 1.33301 10.4311 1.44441 10.5547 1.62987L11.6901 3.33301H14C15.1046 3.33301 16 4.22844 16 5.33301V12.6663C16 13.7709 15.1046 14.6663 14 14.6663H2C0.895431 14.6663 0 13.7709 0 12.6663V5.33301C0 4.22844 0.895431 3.33301 2 3.33301H4.30988L5.4453 1.62987ZM6.35679 2.66634L5.22137 4.36947C5.09772 4.55494 4.88957 4.66634 4.66667 4.66634H2C1.63181 4.66634 1.33333 4.96482 1.33333 5.33301V12.6663C1.33333 13.0345 1.63181 13.333 2 13.333H14C14.3682 13.333 14.6667 13.0345 14.6667 12.6663V5.33301C14.6667 4.96482 14.3682 4.66634 14 4.66634H11.3333C11.1104 4.66634 10.9023 4.55494 10.7786 4.36947L9.64321 2.66634H6.35679Z",
    fill: "#3B465F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6665 8.66634C4.6665 6.82539 6.15889 5.33301 7.99984 5.33301C9.84079 5.33301 11.3332 6.82539 11.3332 8.66634C11.3332 10.5073 9.84079 11.9997 7.99984 11.9997C6.15889 11.9997 4.6665 10.5073 4.6665 8.66634ZM7.99984 6.66634C6.89527 6.66634 5.99984 7.56177 5.99984 8.66634C5.99984 9.77091 6.89527 10.6663 7.99984 10.6663C9.10441 10.6663 9.99984 9.77091 9.99984 8.66634C9.99984 7.56177 9.10441 6.66634 7.99984 6.66634Z",
    fill: "#3B465F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.6d6a2f643cad2e97678a73dbf3d0e097.svg";
export { ForwardRef as ReactComponent };